const getCrypto = (): Crypto | undefined =>
  typeof globalThis.crypto === "undefined" ? undefined : globalThis.crypto;

const createRandomHex = (cryptoApi: Crypto): string =>
  Array.from(cryptoApi.getRandomValues(new Uint8Array(16)))
    .map((value) => value.toString(16).padStart(2, "0"))
    .join("");

const createTimestampId = (): string =>
  `id_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;

export const createClientId = (): string => {
  const cryptoApi = getCrypto();

  return typeof cryptoApi?.randomUUID === "function"
    ? cryptoApi.randomUUID()
    : typeof cryptoApi?.getRandomValues === "function"
      ? `id_${createRandomHex(cryptoApi)}`
      : createTimestampId();
};
